import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DamageStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-damage-status',
  templateUrl: './damage-status.component.html',
  styleUrls: ['./damage-status.component.scss'],
})
export class DamageStatusComponent implements OnChanges {
  damagestatusForm: FormGroup;
  damagestatusFormArray: FormGroup;
  control = new FormControl();
  @Input() damagestatuss: DamageStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() damagestatus = new EventEmitter<DamageStatusDto[]>();
  @Output() deleteDamageStatusEvent = new EventEmitter<any>();

  selectedDamageStatus: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createDamageStatusForm();
  }

  createDamageStatusForm() {
    this.damagestatusForm = this.fb.group({
      DamageStatusName: ['', Validators.required],
      id: null,
    });
    this.damagestatusFormArray = this.fb.group({
      DamageStatuss: this.fb.array([]),
    });
    this.setDamageStatus();
  }

  // method to display damagestatuss
  setDamageStatus() {
    const control = this.damagestatusFormArray.controls
      .DamageStatuss as FormArray;
    this.damagestatuss.forEach((e) => {
      control.push(
        this.fb.group({
          DamageStatusName: e.DamageStatusName,
          id: e.id,
        })
      );
    });
  }

  // method to add DamageStatus
  addDamageStatus(value: DamageStatusDto) {
    const control = this.damagestatusFormArray.controls
      .DamageStatuss as FormArray;
    control.insert(
      0,
      this.fb.group({
        DamageStatusName: value.DamageStatusName,
        id: null,
      })
    );
  }

  selectDamageStatus(value) {}

  // method to delete damagestatus from arrary list
  deleteDamageStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.damagestatusFormArray.controls
          .DamageStatuss as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.damagestatuss.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.damagestatuss[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: DamageStatusDto) {
    if (this.damagestatusForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.damagestatusFormArray
        .get('DamageStatuss')
        ['controls'][this.selectedIndex].patchValue({
          DamageStatusName: formValue.DamageStatusName,
        });
    } else {
      this.addDamageStatus(formValue);
    }
    this.selectedIndex = null;
    this.damagestatusForm.reset();
  }

  onEdit(index, value: DamageStatusDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.damagestatusForm.patchValue({
      DamageStatusName: value.DamageStatusName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.damagestatusForm.reset();
  }

  onSubmit(formValue: DamageStatusDto[]) {
    this.damagestatus.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteDamageStatusEvent.emit(this.filteredDelete);
    }
  }
}
